var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',{staticClass:"fixed-header",attrs:{"id":"apps"}},[_c('main-sidebar'),_c('main-header'),(_vm.is_loading)?_c('floating-loader-component'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }